// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"AdModal_sliderWrapper__2tYsB","slickDots":"AdModal_slickDots__30PLm","checkbox":"AdModal_checkbox__3YhdJ"};